export const SATOSHI = 'Satoshi';
export const MONTSERRAT_ALTERNATES = 'Montserrat Alternates';
